import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { useCallback } from "react";

/**
 * Returns a navigate function that automatically prepends the current language prefix.
 * Usage: const navigate = useLocalizedNavigate();
 *        navigate("/create") => navigates to "/sv/create" or "/en/create"
 */
export function useLocalizedNavigate() {
  const rawNavigate = useNavigate();
  const { language } = useLanguage();

  return useCallback(
    (path: string) => {
      // Don't prefix absolute URLs or paths that already have a language prefix
      if (path.startsWith("/sv/") || path.startsWith("/en/") || path.startsWith("/sv") && path.length === 3 || path.startsWith("/en") && path.length === 3) {
        rawNavigate(path);
      } else {
        rawNavigate(`/${language}${path}`);
      }
    },
    [rawNavigate, language]
  );
}

/**
 * Returns a path with the current language prefix.
 * Usage: const path = useLocalizedPath("/create") => "/sv/create"
 */
export function useLocalizedPath(path: string) {
  const { language } = useLanguage();
  return `/${language}${path}`;
}
